import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SuspendedMatchComponent } from './suspended-match.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [SuspendedMatchComponent],
    exports: [SuspendedMatchComponent]
})
export class SuspendedMatchComponentModule { }
